export const numToFixed = (num: number): number => {
  // const stringNum = num.toString();
  // const dotIndex = stringNum.indexOf(".") === -1 ? stringNum.length : (stringNum.indexOf(".")) + 3;
  // return Number(stringNum.slice(0, dotIndex));
  // return Number.parseFloat(num.toFixed(2));
  return Math.round(num * 100) / 100;
};
